import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";

// Heavy chunk: wallet-adapter (~250KB gzipped), spl-token, qrcode.react.
// Code-split so dashboard users who never reach a /pay page never pay
// the bundle cost. The page above this widget is a payment screen, so
// a brief loading flash is acceptable — typically masked by the
// surrounding card skeleton.
const PayWidgetInner = lazy(() => import("./PayWidgetInner"));

export interface PayWidgetProps {
  /** Solana base58 address that receives the USDC transfer. */
  recipient: string;
  /** Amount in USDC (decimal string, e.g. "10.000000"). */
  amountUsdc: string;
  /** Used as the Solana Pay QR label + transaction memo prefix. */
  projectName: string;
  /** UUID of the payment row, used as on-chain reference. */
  paymentId: string;
}

export function PayWidget(props: PayWidgetProps) {
  return (
    <Suspense
      fallback={
        <div className="card flex items-center justify-center gap-3 py-12 text-sm text-ink/55">
          <Loader2 size={16} className="animate-spin" />
          Loading wallet…
        </div>
      }
    >
      <PayWidgetInner {...props} />
    </Suspense>
  );
}
